/**
 * OneTrust calls a single global `window.OptanonWrapper` whenever the consent banner state
 * changes or consent is granted/updated. Multiple independent features in this app need to react
 * to that callback (banner padding, Dreamdata consent activation). Since only one function can be
 * assigned to `window.OptanonWrapper` at a time, this registry lets each feature register its own
 * callback without clobbering the others.
 *
 * Usage:
 * import optanonWrapperRegistry from 'client/util/oneTrust/optanonWrapperRegistry';
 * optanonWrapperRegistry.registerOptanonWrapperCallback(() => { ... });
 */
const callbacks = [];

function runCallbacks() {
  callbacks.forEach((callback) => {
    try {
      callback();
    } catch (e) {
      // Swallow so one listener's error doesn't prevent the others from running
    }
  });
}

function registerOptanonWrapperCallback(callback) {
  if (typeof callback !== 'function') return;

  callbacks.push(callback);
  window.OptanonWrapper = runCallbacks;
}

export default { registerOptanonWrapperCallback };
